import { CKEditor } from '@ckeditor/ckeditor5-react';
import { ClassicEditor } from 'ckeditor5';

import { CK_EDITOR_CONFIG } from './ckEditorConfig';

interface FormItemInputProps {
	onChange: (value: string) => void;
}

function RichInput({ onChange }: FormItemInputProps) {
	return <CKEditor editor={ClassicEditor} config={CK_EDITOR_CONFIG} onChange={(_, editor) => onChange(editor.getData())} />;
}

export default RichInput;
